export default function isLightboxFormSandbox(
    lightboxEl: HTMLElement | null
): boolean | null {
    if (!lightboxEl) return null;
    return lightboxEl.classList.contains('js-leadform-form-sandbox');
}
